import HistoricTrend from "./HistoricTrend";
import "./HistoricTrend.scss";

export default HistoricTrend;